<template>
	<section v-show="isActive" :id="indexedId">
		<template v-if="shouldMount">
			<slot :tab-index="tabIndex"/>
		</template>
	</section>
</template>
<script>
export default {
	data() {
		return {
			persistMount: false,
		};
	},
	props: {
		mountOnShow: {
			type: Boolean,
			required: false,
			default() {
				return false;
			},
		},
		mountOnce: {
			type: Boolean,
			required: false,
			default() {
				return false;
			},
		},
		excludeFromTabSteps: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
		tabKey: {
			required: false,
		},
		id: {
			required: true,
			type: String,
		},
		idIndex: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
		label: {required: true},
		selected: {default: false},
		onShow: {
			required: false,
			type: Function,
		},
	},

	computed: {
		indexedId() {
			return (this.idIndex ? [this.id, this.idIndex] : [this.id]).join("-");
		},
		shouldMount() {
			return this.isActive || this.persistMount || (!this.mountOnShow && !this.$parent.mountOnShow);
		},
		isActive() {
			return this.$parent.selectedTab && this.$parent.selectedTab.indexedId === this.indexedId;
		},
		tabIndex() {
			return this.$parent.tabIndex(this);
		},
		href() {
			return "#" + this.indexedId;
		},
	},

	methods: {
		mount() {
			if (this.mountOnce || this.$parent.mountOnce) {
				this.persistMount = true;
			}
		},
		callOnShow() {
			if (!this.onShow) {
				return;
			}
			this.onShow();
		},
		getTabKey() {
			return this.tabKey;
		},
	},

	created() {
		this.$parent.addTab(this);
	},

	destroyed() {
		this.$parent.removeTab(this);
	},
};
</script>
